/**
 * @generated SignedSource<<56881386bab9a7cdc5a8879c5df63fba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
import { FragmentRefs } from "relay-runtime";
export type WidgetCalendar_widgetCalendar$data = {
  readonly events: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetCalendarEvent_teamScheduleOneOffEvent">;
  }>;
  readonly id: string;
  readonly overviewSize: WidgetOverviewSize;
  readonly " $fragmentType": "WidgetCalendar_widgetCalendar";
};
export type WidgetCalendar_widgetCalendar$key = {
  readonly " $data"?: WidgetCalendar_widgetCalendar$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetCalendar_widgetCalendar">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetCalendar_widgetCalendar",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overviewSize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamScheduleOneOffEvent",
      "kind": "LinkedField",
      "name": "events",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetCalendarEvent_teamScheduleOneOffEvent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetCalendar",
  "abstractKey": null
};
})();

(node as any).hash = "59710c08ae5344635d4599f5745f83a9";

export default node;
